module.exports = __webpack_public_path__ + "assets/webgl/LM.6.24ba5fab.jpg";